var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCandidateExperience(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22398",
    "data-name": "Group 22398",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.306,
    height: 22.303,
    viewBox: "0 0 22.306 22.303",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-555"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2008",
    "data-name": "Rectangle 2008",
    width: 22.306,
    height: 22.303,
    fill: "#040227"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22397",
    "data-name": "Group 22397",
    clipPath: "url(#clip-path-555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11595",
    "data-name": "Path 11595",
    d: "M111.071,12.315a.372.372,0,0,0,.245.7,6.693,6.693,0,1,0-4.383,0,.372.372,0,1,0,.244-.7,5.933,5.933,0,0,1-1.772-.985v-.4a2.8,2.8,0,0,1,1.8-2.615,3.325,3.325,0,0,0,3.844,0,2.8,2.8,0,0,1,1.8,2.615v.406A5.933,5.933,0,0,1,111.071,12.315ZM106.52,5.575a2.6,2.6,0,1,1,2.6,2.6,2.6,2.6,0,0,1-2.6-2.6m5.13,2.183a3.346,3.346,0,1,0-5.059,0,3.542,3.542,0,0,0-1.918,2.872,5.948,5.948,0,1,1,8.9,0,3.54,3.54,0,0,0-1.921-2.872",
    transform: "translate(-97.968)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11596",
    "data-name": "Path 11596",
    d: "M138.61,294.742a.738.738,0,0,0,.781.06l2.419-1.257,2.418,1.257a.743.743,0,0,0,1.075-.787l-.459-2.651,1.944-1.874a.743.743,0,0,0-.409-1.271l-2.7-.388-1.2-2.421a.744.744,0,0,0-1.332,0l-1.211,2.422-2.693.387a.743.743,0,0,0-.409,1.271l1.945,1.874-.46,2.651A.74.74,0,0,0,138.61,294.742Zm-1.264-5.787,2.885-.415a.372.372,0,0,0,.28-.2l1.3-2.6,1.293,2.6a.372.372,0,0,0,.28.2l2.891.415-2.087,2.011a.372.372,0,0,0-.108.331l.493,2.846-2.59-1.346a.372.372,0,0,0-.343,0l-2.59,1.346.493-2.846a.372.372,0,0,0-.108-.331Z",
    transform: "translate(-130.653 -272.584)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11597",
    "data-name": "Path 11597",
    d: "M1.749,262.357l-.363,2.1a.672.672,0,0,0,.972.715l1.919-1,1.917,1a.372.372,0,0,0,.343-.659l-2.089-1.089a.372.372,0,0,0-.343,0l-1.962,1.022.372-2.156a.372.372,0,0,0-.108-.331L.828,260.436l2.185-.314a.372.372,0,0,0,.28-.2l.984-1.968.981,1.968a.372.372,0,0,0,.28.2l2.334.335a.372.372,0,1,0,.105-.736l-2.141-.307-.958-1.923a.669.669,0,0,0-.6-.372h0a.661.661,0,0,0-.595.37l-.963,1.925L.58,259.72a.669.669,0,0,0-.372,1.149Z",
    transform: "translate(0 -245.919)",
    fill: "#040227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11598",
    "data-name": "Path 11598",
    d: "M329.945,260.136a.662.662,0,0,0-.543-.456l-2.137-.307-.961-1.924a.663.663,0,0,0-.595-.372h0a.669.669,0,0,0-.6.372l-.958,1.922-2.142.307a.372.372,0,0,0,.105.736l2.335-.335a.372.372,0,0,0,.28-.2l.978-1.965.982,1.968a.372.372,0,0,0,.28.2l2.184.313-1.579,1.524a.372.372,0,0,0-.108.331l.374,2.156-1.962-1.023a.372.372,0,0,0-.343,0l-2.089,1.089a.372.372,0,0,0,.343.659l1.919-1,1.918,1a.672.672,0,0,0,.972-.713l-.362-2.1,1.541-1.487A.669.669,0,0,0,329.945,260.136Z",
    transform: "translate(-307.673 -245.879)",
    fill: "#040227"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCandidateExperience);
export default __webpack_public_path__ + "static/media/icon-candidate-experience.7e01d3e0175dd1a80d97cf147fcfb748.svg";
export { ForwardRef as ReactComponent };